import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from 'assets/Refresh.svg';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import { Box, IconButton } from '@material-ui/core';
import PartSalesServices from 'lib/services/api/commercial/parts';
import tableIcons, { options } from 'components/universal/table_attributes';



export default function CostDate(props) {
    const { workshopId, setCostData, handleCalculation, tab } = props
    const [data, setData] = useState([])

    const getDetails = async () => {
        const params = { workshop_order_id: workshopId };

        try {
            const response = await PartSalesServices.getCostDetails(params);


            if (response?.data) {
                setData([response.data]); //
                setCostData(response?.data)
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error in getDetails:", error);
            setData([]);
        }
    };

    useEffect(() => {
        if (workshopId) {
            getDetails()
        }
    }, [workshopId])


    const handleUpdateCost = (newData, oldData, rowData) => {

        // oldData
        const oldLabour = parseFloat(oldData.labour) || 0;
        const oldParts = parseFloat(oldData.parts) || 0;
        const oldService = parseFloat(oldData.service) || 0;
        const oldEquipment = parseFloat(oldData.equipment) || 0;
        // newData

        const labour = parseFloat(newData.labour) || 0;
        const parts = parseFloat(newData.parts) || 0;
        const service = parseFloat(newData.service) || 0;
        const equipments = parseFloat(newData.equipment) || 0;
        const total = labour + parts + service + equipments;



        let values = data.map((item) => {
            return {
                ...item,
                labour: newData.labour,
                parts: newData.parts,
                service: newData.service,
                equipment: newData.equipment,
                total: total.toFixed(2),

            }

        })

        let costObj = {
            labour_cost: oldLabour,
            parts_cost: oldParts,
            service_cost: oldService,
            equipment_cost: oldEquipment,
        }


        setData(values)
        setCostData(values[0])

        if (tab === "core") {

            handleCalculation(costObj)
        }

    }

    const columns = [
        {
            title: 'Costs to Date',
            field: 'title',
            editable: 'never',
            cellStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: "40%"
            },
            headerStyle: {
                textAlign: "left",
                paddingLeft: "15px",
                width: "40%"
            },
            render: (rowData) => <span>Costs to Date</span>

        },
        {
            title: 'Labour',
            field: 'labour',

        },
        {
            title: 'Parts',
            field: 'parts',

        },
        {
            title: 'Services',
            field: 'service',

        },
        {
            title: 'Equipment',
            field: 'equipment',
        },
        {
            title: 'Total',
            field: 'total',
            editable: 'never',
        },
        {
            title: "",
            width: "4%",
            headerStyle: {
                textAlign: "left",
                width: "4%",
            },
            cellStyle: {
                textAlign: "left",
                width: "4%",
                // padding: "14px 10px",
            },
            render: (rowData) => <>
                <IconButton onClick={
                    () => {
                        getDetails()
                    }}>
                    <img src={RefreshIcon} height={"15px"} style={{ marginLeft: "-38px", fontSize: "17px" }} />
                </IconButton>
            </>



        }
    ];



    return (
        <Box mb={"10px"}>
            <MaterialTable
                title=""
                columns={columns}
                icons={tableIcons}
                data={data}
                options={{
                    ...options,
                    paging: false,
                    search: false,
                    toolbar: false,
                    actionsColumnIndex: 6,
                }}
                editable={{

                    onRowUpdate: (newData, oldData, rowData) =>
                        new Promise((resolve, reject) => {
                            handleUpdateCost(newData, oldData)
                            resolve();
                        }),
                }}

            />



        </Box>
    )
}
